<app-cashback-popup></app-cashback-popup>
<app-connect-popup></app-connect-popup>
<app-share-popup></app-share-popup>
<app-compare-offer-popup></app-compare-offer-popup>
<!-- <ng-container #popupContainer></ng-container> -->
<div *ngIf="ratingsService.displayRating || ratingsService.displayThankYou">
  <app-rating-popup></app-rating-popup>
</div>

<app-sample-dcp></app-sample-dcp>